var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 496 496",
        "xml:space": "preserve",
        width: "20px",
        height: "20px",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("g", [
            _c("g", [
              _c("path", {
                attrs: {
                  d: "M187.872,51.752c10.184,8.144,16.832,19.496,19.152,32.04l-28.056-11.224l-5.936,14.856L216,104.616l42.968-17.184 l-5.936-14.856l-29.688,11.872c-2.328-17.712-11.288-33.84-25.472-45.184C185.584,29.416,170.144,24,154.392,24H152v16h2.392 C166.52,40,178.416,44.168,187.872,51.752z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M308.128,444.248c-10.184-8.144-16.832-19.496-19.152-32.04l28.056,11.224l5.936-14.856L280,391.384l-42.968,17.184 l5.936,14.856l29.688-11.872c2.328,17.712,11.288,33.84,25.472,45.184c12.288,9.848,27.728,15.264,43.48,15.264H344v-16h-2.392 C329.48,456,317.584,451.832,308.128,444.248z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M424,352c-11.504,0-22.344,2.776-32,7.6V217.544l16.568,41.424l14.856-5.936l-11.872-29.688 c17.712-2.328,33.84-11.288,45.184-25.472c9.848-12.288,15.264-27.728,15.264-43.48V152h-16v2.392 c0,12.136-4.168,24.024-11.752,33.488c-8.144,10.184-19.496,16.832-32.04,19.152l11.224-28.056l-14.856-5.936L392,214.456V136.4 c9.656,4.816,20.496,7.6,32,7.6c39.704,0,72-32.296,72-72S463.704,0,424,0c-39.704,0-72,32.296-72,72 c0,27.872,15.944,52.04,39.16,64H104.84C128.056,124.04,144,99.872,144,72c0-39.704-32.296-72-72-72S0,32.296,0,72 s32.296,72,72,72c11.504,0,22.344-2.776,32-7.6v142.056l-16.568-41.424l-14.856,5.936l11.872,29.688 c-17.712,2.328-33.84,11.288-45.184,25.472C29.416,310.416,24,325.856,24,341.608V344h16v-2.392 c0-12.136,4.168-24.024,11.752-33.488c8.144-10.184,19.496-16.832,32.04-19.152l-11.224,28.056l14.856,5.936L104,281.544V359.6 c-9.656-4.824-20.496-7.6-32-7.6c-39.704,0-72,32.296-72,72c0,39.704,32.296,72,72,72s72-32.296,72-72 c0-27.872-15.944-52.04-39.16-64h286.328C367.944,371.96,352,396.128,352,424c0,39.704,32.296,72,72,72c39.704,0,72-32.296,72-72 C496,384.296,463.704,352,424,352z M96,122.52c-7.288,3.472-15.408,5.48-24,5.48s-16.712-2.008-24-5.48V112 c0-13.232,10.768-24,24-24s24,10.768,24,24V122.52z M56,56c0-8.824,7.176-16,16-16s16,7.176,16,16s-7.176,16-16,16 S56,64.824,56,56z M96,474.52c-7.288,3.472-15.408,5.48-24,5.48s-16.712-2.008-24-5.48V464c0-13.232,10.768-24,24-24 s24,10.768,24,24V474.52z M56,408c0-8.824,7.176-16,16-16s16,7.176,16,16c0,8.824-7.176,16-16,16S56,416.824,56,408z M128,424 c0,15.256-6.152,29.088-16.08,39.2c-0.272-13.448-7.144-25.312-17.568-32.36C100.288,425.032,104,416.952,104,408 c0-17.648-14.352-32-32-32s-32,14.352-32,32c0,8.952,3.712,17.032,9.648,22.84c-10.424,7.056-17.296,18.912-17.568,32.36 C22.152,453.088,16,439.256,16,424c0-30.872,25.128-56,56-56S128,393.128,128,424z M94.352,78.84 C100.288,73.032,104,64.952,104,56c0-17.648-14.352-32-32-32S40,38.352,40,56c0,8.952,3.712,17.032,9.648,22.84 C39.224,85.896,32.352,97.752,32.08,111.2C22.152,101.088,16,87.256,16,72c0-30.872,25.128-56,56-56s56,25.128,56,56 c0,15.256-6.152,29.088-16.08,39.2C111.648,97.752,104.776,85.888,94.352,78.84z M376,344H120V216h256V344z M376,200H120v-48h256 V200z M448,122.52c-7.288,3.472-15.408,5.48-24,5.48c-8.592,0-16.712-2.008-24-5.48V112c0-13.232,10.768-24,24-24 s24,10.768,24,24V122.52z M408,56c0-8.824,7.176-16,16-16c8.824,0,16,7.176,16,16s-7.176,16-16,16C415.176,72,408,64.824,408,56z M384.08,111.2C374.152,101.088,368,87.256,368,72c0-30.872,25.128-56,56-56s56,25.128,56,56c0,15.256-6.152,29.088-16.08,39.2 c-0.272-13.448-7.144-25.312-17.568-32.36C452.288,73.032,456,64.952,456,56c0-17.648-14.352-32-32-32s-32,14.352-32,32 c0,8.952,3.712,17.032,9.648,22.84C391.216,85.896,384.344,97.752,384.08,111.2z M448,474.52c-7.288,3.472-15.408,5.48-24,5.48 c-8.592,0-16.712-2.008-24-5.48V464c0-13.232,10.768-24,24-24s24,10.768,24,24V474.52z M408,408c0-8.824,7.176-16,16-16 c8.824,0,16,7.176,16,16c0,8.824-7.176,16-16,16C415.176,424,408,416.824,408,408z M463.92,463.2 c-0.272-13.448-7.144-25.312-17.568-32.36C452.288,425.032,456,416.952,456,408c0-17.648-14.352-32-32-32s-32,14.352-32,32 c0,8.952,3.712,17.032,9.648,22.84c-10.432,7.056-17.304,18.912-17.568,32.36C374.152,453.088,368,439.256,368,424 c0-30.872,25.128-56,56-56s56,25.128,56,56C480,439.256,473.848,453.088,463.92,463.2z",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "136", y: "168", width: "16", height: "16" },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "168", y: "168", width: "16", height: "16" },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "200", y: "168", width: "16", height: "16" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M264,232H136v96h128V232z M248,312h-96v-64h96V312z",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "280", y: "232", width: "80", height: "16" },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "280", y: "264", width: "80", height: "16" },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: { x: "280", y: "296", width: "80", height: "16" },
              }),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }